import { BackendResponse } from "../BackendResponse";
import { FormDataWithKeyCheck } from "../FormDataFactory";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface QuickApplyConnectResponse extends BackendResponse {
  item: string;
}

export interface _QuickApplyConnectParameters extends NextApiParams {
  formData: FormDataWithKeyCheck<QuickApplyConnectParameters>;
}

export const quickApplyConnect = withNextApi<
  QuickApplyConnectResponse,
  _QuickApplyConnectParameters
>("Auth/QuickApplyConnect");

export interface QuickApplyConnectParameters {
  concernId: number;
  relatedId: number;
  relatedType: number;
  consent: boolean;
  enableParameterOverride: boolean;
}
